import { IReport } from "@/entities";
import { EUserType, IPaged, IPageResponse } from "@/services";
import { AxiosResponse } from "axios";

export interface IReportService {
  getReportsPage(sort?: IReportRequest): Promise<IPageResponse<IReport> | undefined>;
  downloadReport(idRequest: number): Promise<AxiosResponse<Blob> | undefined>;
  deleteReport(idRequest: number): Promise<void>;
}

export interface IReportRequest extends IPaged {
  status?: EReportStatus;
  requestDate?: Date | string;
  reportDate?: Date | string;
  filename?: string;
  username?: string;
  usernamePrecise?: boolean;
  countryId?: number;
  userType?: EUserType;
  reportType?: EReportType;
}

export enum EReportStatus {
  RECEIVED = "RECEIVED",
  PROCESSING = "PROCESSING",
  UPLOADED = "UPLOADED",
  ERROR = "ERROR",
}

export enum EReportType {
  USERS = "USERS",
  ORDERS = "ORDERS",
  EMPLOYEE_SEARCH = "EMPLOYEE_SEARCH",
  SUBCLIENT = "SUBCLIENT",
  SERVICE_POINT = "SERVICE_POINT",
  CLIENT = "CLIENT",
  ORDER_APPROVALS = "ORDER_APPROVALS",
}

export interface IReportFilter {
  status?: boolean;
  requestDate?: boolean;
  reportDate?: boolean;
  username?: boolean;
  usernamePrecise?: boolean;
  countryId?: boolean;
  userType?: boolean;
}

export interface IReportServiceMock {
  getReportsPage: jest.Mock<Promise<IPageResponse<IReport> | undefined>>;
  downloadReport: jest.Mock<Promise<AxiosResponse<Blob> | undefined>>;
  deleteReport: jest.Mock<Promise<void | undefined>>;
}
